import React, {
  ReactNode,
  createContext,
  useContext,
  useRef,
} from "react";
import CustomFlashBar from "./CustomFlashBar";
import { FlashbarProps } from "@cloudscape-design/components";

interface FlashbarContextProps {
  addFlashbarItem: (item: FlashbarProps.MessageDefinition, duration?: number) => void;
  setFlashbarItem: (item: FlashbarProps.MessageDefinition, duration?: number) => void;
  clearFlashbarItems: () => void;
}

const FlashbarContext = createContext<FlashbarContextProps | null>(null);

export const FlashbarProvider = ({ children }: { children: ReactNode }) => {
  const flashbarRef = useRef(null);

  const addFlashbarItem = (item, duration) => {
    flashbarRef.current.addFlashbarItem(item, duration);
  };

  const setFlashbarItem = (item, duration) => {
    flashbarRef.current.setFlashbarItem(item, duration);
  };

  const clearFlashbarItems = () => {
    flashbarRef.current.clearFlashbarItems();
  };

  return (
    <FlashbarContext.Provider value={{
      addFlashbarItem,
      setFlashbarItem,
      clearFlashbarItems,
    }}>
      <CustomFlashBar ref={flashbarRef} />
      {children}
    </FlashbarContext.Provider>
  );
};

export const useFlashbarContext = () => {
  const context = useContext(FlashbarContext);

  if (!context) {
    throw new Error("Context must be used inside a provider");
  }

  return context;
};